/**
 * tracklog统计
 * 使用方法：
 * mTracklog({pagetype:1111})    //根据产品提供的埋点信息传递参数
 * 非58app触发
 */
import { is58App } from './appTools';
import { loadScript } from './tools';
export var mTracklog = function (opts) {
    if (opts === void 0) { opts = {
        pagetype: '',
        page: '',
        cate_lv1: '',
        cate_lv2: '',
        cate_lv3: '',
        brand_id: '',
        manu_id: '',
        line_id: '',
        prd_id: '',
        info_id: '',
        from: '',
    }; }
    // 58app不触发
    if (is58App()) {
        return false;
    }
    if (typeof window.getFrom == 'undefined') {
        loadScript({
            url: '//ss.xgo-img.com.cn/public/js/from.js',
        }).then(function () {
            sendMTracklog();
        });
    }
    else {
        sendMTracklog();
    }
    function sendMTracklog() {
        opts.from = opts.from || window.getFrom();
        window._trackURL = JSON.stringify(opts);
        loadScript({ url: '//tracklog.58.com/referrer_58che_m.js' });
    }
};
